import { ExternalLink } from "lucide-react";
import { useLang } from "@/lib/i18n";

const toEmbed = (url) => {
  try {
    const u = new URL(url);
    const host = u.hostname.replace(/^www\./, "");
    if (host === "youtu.be") return { src: `https://www.youtube.com/embed/${u.pathname.slice(1).split("/")[0]}`, platform: "YouTube" };
    if (host.endsWith("youtube.com")) {
      if (u.searchParams.get("v")) return { src: `https://www.youtube.com/embed/${u.searchParams.get("v")}`, platform: "YouTube" };
      const m = u.pathname.match(/^\/(live|embed|shorts)\/([\w-]+)/);
      if (m) return { src: `https://www.youtube.com/embed/${m[2]}`, platform: "YouTube" };
      return { src: null, platform: "YouTube" };
    }
    if (host.endsWith("facebook.com") || host === "fb.watch") {
      return { src: `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false`, platform: "Facebook" };
    }
    if (host.endsWith("twitch.tv")) {
      const channel = u.pathname.slice(1).split("/")[0];
      if (channel) return { src: `https://player.twitch.tv/?channel=${channel}&parent=${window.location.hostname}`, platform: "Twitch" };
    }
  } catch {}
  return { src: null, platform: null };
};

export const LivestreamPlayer = ({ url }) => {
  const { t } = useLang();
  if (!url) return null;
  const { src, platform } = toEmbed(url);
  if (!src) return null;

  return (
    <div className="mt-8" data-testid="event-livestream-player">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[11px] font-mono-data uppercase tracking-wider text-muted-foreground flex items-center gap-2">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" />
          </span>
          {t("live_broadcast")}
        </p>
        <a href={url} target="_blank" rel="noreferrer" data-testid="livestream-external-link" className="text-xs text-accent hover:underline flex items-center gap-1">
          {t("watch_on").replace("{platform}", platform)} <ExternalLink className="h-3 w-3" />
        </a>
      </div>
      <div className="relative w-full rounded-xl overflow-hidden border border-border bg-black" style={{ paddingBottom: "56.25%" }}>
        <iframe
          src={src}
          title="Livestream"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowFullScreen
          className="absolute inset-0 w-full h-full"
        />
      </div>
    </div>
  );
};
